export default {

	icon: {
		1: 'person',
		2: 'lungs',
		3: 'rx',
		4: 'stethoscope',
		5: 'star',
		6: 'check',
		7: 'density',
		8: 'speech',
		9: 'cross',
		10: 'question',
		11: 'improve',
		12: 'summary',
		13: 'book'
	},

	track: {
		context: {
			input: 1,
			section: 2
		}
	},

	logic: {

		variable: {

			type: {
				boolean: 1,
				number: 2,
				text: 3,
				set: 4,
				option: 5
			}

		},

		comparison: {
			equal: 1,
			notequal: 2,
			lessthan: 3,
			morethan: 4,
			lessthanorequal: 5,
			morethanorequal: 6
		},

		operand: {
			and: 'AND',
			or: 'OR',
			nand: '!AND',
			nor: '!OR'
		}

	},

	recommendation: {

		text: {
			off: 0,
			text: 1,
			blocks: 2
		}

	},

	block: {

		type: {
			text: 1,
			bullet: 2
		}

	},

	alert: {

		type: {

			warning: 1,
			error: 2,
			info: 3,
			live: 4

		}

	},

	default: {

		none: 0,
		specific: 1,
		automatic: 2

	},

	required: {

		never: 0,
		always: 1,
		sometimes: 2

	},

	visibility: {

		required: 0,
		always: 1,
		sometimes: 2

	},

	button: {

		type: {

			proceed: 1,
			exit: 2,
			finish: 3,
			review: 4

		}

	},

	layout: {

		type: {

			input: 1,
			grid: 2,
			group: 3,
			text: 4

		}

	},

	input: {

		type: {

			textbox: 1,
			textarea: 2,
			toggle: 3,
			checkbox: 4,
			checklist: 8,
			date: 5,
			number: 6,
			select: 7,
			scale: 9

		}

	},

	section: {

		type: {

			standard: 1,
			nextstep: 2,
			patient: 3

		}

	},

	action: {

		type: {

			bridge: 1,
			navigate: 2,
			print: 3,
			referral: 4,
			exit: 5

		}

	}

}